import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class AfbService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async afbPreloadWorkers(data) {
        const pos = getPosition();
        const response = await API.service('afbPreloadWorkers', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbInvestmentGetActive(data) {
        const pos = getPosition();
        const response = await API.service('afbInvestmentGetActive', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbInvestmentCreate(data) {
        const pos = getPosition();
        const response = await API.service('afbInvestmentCreate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbInvestmentComplete(data) {
        const pos = getPosition();
        const response = await API.service('afbInvestmentComplete', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbCustomersList(data) {
        const pos = getPosition();
        const response = await API.service('afbCustomers', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbCompanyCards(data) {
        const pos = getPosition();
        const response = await API.service('companyCards', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbContactList(data) {
        const pos = getPosition();
        const response = await API.service('contactList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbGetAccounts(data) {
        const pos = getPosition();
        const response = await API.service('getAccounts', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbClabeCreate(data) {
        const pos = getPosition();
        const response = await API.service('afbClabeCreate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async afbAdminList(data) {
        const pos = getPosition();
        const response = await API.service('adminAbbList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbAdminUpdate(data) {
        const pos = getPosition();
        const response = await API.service('updateAbbUser', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbAdminCreate(data) {
        const pos = getPosition();
        const response = await API.service('addAbbUser', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbResendEmail(data) {
        const pos = getPosition();
        const response = await API.service('afbResendEmail', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async otpTokenGetAllowed(data) {
        const pos = getPosition();
        const response = await API.service('otpTokenGetAllowed', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async otpTokenDisabledConfirm(data) {
        const pos = getPosition();
        const response = await API.service('otpTokenDisabledConfirm', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbValidateSession(data) {
        const pos = getPosition();
        const response = await API.service('afbValidateSession', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async afbRecurringList(data) {
        const pos = getPosition();
        const response = await API.service('afbRecurringList', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async afbRecurringSave(data) {
        const pos = getPosition();
        const response = await API.service('afbRecurringSave', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async afbRecurringUpdate(data) {
        const pos = getPosition();
        const response = await API.service('afbRecurringUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    // ─── Fee simulation & charge ─────────────────────────────────────────────────

    async afbFeeSimulateBatch(data) {
        const pos = getPosition();
        const response = await API.service('afbFeeSimulateBatch', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbFeeChargeBatch(data) {
        const pos = getPosition();
        const response = await API.service('afbFeeChargeBatch', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbFeeSimulateSingle(data) {
        const pos = getPosition();
        const response = await API.service('afbFeeSimulateSingle', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbFeeChargeSingle(data) {
        const pos = getPosition();
        const response = await API.service('afbFeeChargeSingle', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbExecutionList(data) {
        const pos = getPosition();
        const response = await API.service('afbExecutionList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbExecutionDetail(data) {
        const pos = getPosition();
        const response = await API.service('afbExecutionDetail', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbFeeDownload(data) {
        const pos = getPosition();
        const response = await API.service('afbFeeDownload', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}